/** One authored icon family: 24px grid, 2.5 stroke, round caps. */
const PATHS = {
  bag: "M6 8h12l-1 12H7L6 8Zm3 0a3 3 0 0 1 6 0",
  arrow: "M5 12h14m-5-5 5 5-5 5",
  "arrow-left": "M19 12H5m5-5-5 5 5 5",
  plus: "M12 5v14M5 12h14",
  minus: "M5 12h14",
  close: "M6 6l12 12M18 6 6 18",
  check: "m5 12.5 4.5 4.5L19 7",
  upload: "M12 16V4m-5 5 5-5 5 5M5 16v3h14v-3",
  link: "M10 14a4 4 0 0 0 5.66 0l3-3a4 4 0 0 0-5.66-5.66l-1 1M14 10a4 4 0 0 0-5.66 0l-3 3a4 4 0 0 0 5.66 5.66l1-1",
  pen: "M4 20h4L19 9l-4-4L4 16v4Zm9-13 4 4",
  truck:
    "M3 6h11v9H3V6Zm11 4h4l3 3v2h-7V10ZM7 18.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm10 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
  print: "M7 9V4h10v5M7 17H5v-6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6h-2M8 14h8v6H8v-6Z",
  user: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-7 8a7 7 0 0 1 14 0",
  image: "M4 5h16v14H4V5Zm0 11 4.5-4.5 4 4L15 13l5 5M15.5 9.5a1 1 0 1 0 0-.01",
  refresh: "M20 11a8 8 0 1 0-2.3 5.7M20 5v6h-6",
  mail: "M4 6h16v12H4V6Zm0 0 8 7 8-7",
  external: "M14 4h6v6m0-6-9 9M18 14v6H4V6h6",
  copy: "M9 9h11v11H9V9ZM5 15V4h11",
  menu: "M4 7h16M4 12h16M4 17h16",
  lock: "M6 11h12v9H6v-9Zm2 0V8a4 4 0 0 1 8 0v3",
  sparkle: "M12 3v4m0 10v4M3 12h4m10 0h4M6 6l2.5 2.5m7 7L18 18M18 6l-2.5 2.5m-7 7L6 18",
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({
  name,
  size,
  className,
  label,
}: {
  name: IconName;
  size?: number;
  className?: string;
  label?: string;
}) {
  return (
    <svg
      className={`icon ${className ?? ""}`}
      width={size ?? 20}
      height={size ?? 20}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      role={label ? "img" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
